import { createSignal } from 'rwwa-rx-state-machine'

/** Used to update currentUrl, example with clean url search params removed */
export const ReplaceCurrentUrl = createSignal<{ url: string; isRacePath?: boolean }>(
  'ReplaceLastRoute'
)
/** ONLY used where legacy router (Nav.js) successfully updates route */
export const NavigatedTo = createSignal<{ url: string }>('NavigatedTo')
